import { styled } from '@mui/styles';
import { Typography } from '@mui/material';

import { COLOR_GRAY_60 } from 'styles/variables/colors';
import { FONT_FAMILY } from 'styles/variables/typography';

export const Container = styled(({ fillColor, marginBottom, mobileCentered, ...props }) => (
  <Typography {...props} />
))((props) => ({
  color: COLOR_GRAY_60,
  fontSize: '1rem',
  fontFamily: FONT_FAMILY,
  fontSize: props.size,
  fontWeight: props.weight,
  color: props.fillColor,
  marginBottom: props.marginBottom && `${props.marginBottom}px`,

  ...(props.mobileCentered
    ? {
        ['@media (max-width: 768px)']: {
          margin: '0 auto',
          maxWidth: 300,
          textAlign: 'center',
          fontSize: 16,
        },
      }
    : {}),
}));
